// extracted by mini-css-extract-plugin
module.exports = {"autocompleteList":"AutocompleteList_autocompleteList__0zvtx","googleImg":"AutocompleteList_googleImg__xw4Mj"};